<template>
    <div class="reply flex wrap center" :class="[{ 'empty': !base.Util().validate(replies) }]">
        <div v-if="base.Util().validate(replies)" class="messages flex wrap center">
            <template v-for="(reply, index) in replies" :key="index">
                <div class="flex vend" :class="reply.class">
                    <img v-lazy="'/images/profile.webp'" height="36" width="36" alt="نمایه کاربری" loading="lazy">
                    <div class="chat flex wrap center">
                        <p>{{ reply.message }}</p>
                        <div class="line"></div>
                        <p>
                            {{ users[reply.uid].name }}
                            <br>
                            {{ users[reply.uid].group }}
                        </p>
                    </div>
                    <span>
                        {{ base.Util().time({ unix: reply.created_at, time: true }) }}
                    </span>
                </div>
            </template>
        </div>
        <div v-if="!disabled" class="message">
            <MetaBox :meta="{ key: meta.key, name: 'متن پیام', type: 'textarea' }"
                @onchange="(obj) => this.$emit('onchange', obj)">
            </MetaBox>
        </div>
    </div>
</template>

<script>
import MetaBox from './MetaBox.vue'

/* eslint-disable */
export default {
    name: 'Reply',
    props: ['meta', 'disabled', 'id'],
    inject: ['base'],
    components: { MetaBox },
    created() {
        if (this.id)
            this.base.API().get(`Support/Reply/Conversation?parent_id=${String(this.meta?.entity_type).toUpperCase()}_${this.id}`
                , (response) => {
                    if (this.base.Util().success(response))
                        if (this.base.Util().validate(response.data.data)) {
                            this.replies = response.data.data
                            this.users = response.data.uid
                        }
                })
    },
    data() {
        return {
            replies: [],
            users: {},
        }
    }
}
</script>

<style scoped src="../../../assets/css/components/inputs/reply.css"></style>
<style scoped src="../../../assets/css/components/inputs/reply_dark.css"></style>